import { useEffect } from 'react';
import { Form } from 'antd';
import { I18n } from 'i18n';
import { Text, Toggle, FormCard } from 'components';
import useComponents from 'hooks/useComponents';
import { Save } from './save';

const stateName = 'configuration.notifications';

export function NotificationEdit({ customer, selectedChannel, onCloseDrawer, onSuccess }) {
  const {
    configuration: { notifications },
    onChange,
  } = useComponents();

  useEffect(() => {
    if (customer && selectedChannel) {
      if (selectedChannel === 'whatsapp') {
        onChange(`${stateName}.waGroupId`, customer.waGroupId || '', true);
        onChange(`${stateName}.waNotifications`, customer.waNotifications ?? false, true);
      } else if (selectedChannel === 'telegram') {
        onChange(`${stateName}.tgGroupId`, customer.tgGroupId || '', true);
        onChange(`${stateName}.tgNotifications`, customer.tgNotifications ?? false, true);
      }
    }
  }, [customer, selectedChannel]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!customer || !selectedChannel) return null;

  const isWhatsApp = selectedChannel === 'whatsapp';

  return (
    <Form layout="vertical">
      <FormCard
        title={I18n('activate_notifications', true)}
        description={I18n('activate_notifications_desc', true)}
      >
        {isWhatsApp ? (
          <>
            <Form.Item label={I18n('wa_group_id', true)}>
              <Text
                value={notifications?.waGroupId}
                default={customer.waGroupId}
                onChange={onChange}
                stateName={`${stateName}.waGroupId`}
                placeholder={I18n('wa_group_id', true)}
                noFormItem
              />
            </Form.Item>
            <Toggle
              isFormItem={true}
              value={notifications?.waNotifications}
              default={customer.waNotifications}
              onChange={onChange}
              stateName={`${stateName}.waNotifications`}
              externalLabel={I18n('wa_notifications', true)}
              label={I18n('wa_notifications', true)}
            />
          </>
        ) : (
          <>
            <Form.Item label={I18n('tg_group_id', true)}>
              <Text
                value={notifications?.tgGroupId}
                default={customer.tgGroupId}
                onChange={onChange}
                stateName={`${stateName}.tgGroupId`}
                placeholder={I18n('tg_group_id', true)}
                noFormItem
              />
            </Form.Item>
            <Toggle
              isFormItem={true}
              value={notifications?.tgNotifications}
              default={customer.tgNotifications}
              onChange={onChange}
              stateName={`${stateName}.tgNotifications`}
              externalLabel={I18n('tg_notifications', true)}
              label={I18n('tg_notifications', true)}
            />
          </>
        )}
      </FormCard>
      <div className="rk-button-group">
        <Save
          customer={customer}
          selectedChannel={selectedChannel}
          onCloseDrawer={onCloseDrawer}
          onSuccess={onSuccess}
        />
      </div>
    </Form>
  );
}
